<template>
  <ul class="more-list">
    <!--<li class="ml-item" @click="skip('c1')">手机号登陆的话,手机不在身边怎么办?<span class="arrows"></span></li>-->
    <li class="ml-item" @click="skip('c4')">登录、激活等的相关问题<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c2')">加入了错误的班级,该如何退出?<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c6')">家里有两个孩子怎么办？<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c11')">如何进行多账号管理<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c12')">家庭账号组怎么管理<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c3')">跟读与背诵时，红色、黑色、蓝色各是什么含义？<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c5')">我点击做作业，提示我“课程未购买”<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c8')">我提交了作业,但老师说没收到！<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c7')">使用中的相关问题<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c13')">如何清除缓存<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c10')">如何修改个人信息<span class="arrows"></span></li>
    <li class="ml-item" @click="skip('c9')">如何注销可瀚学堂账号<span class="arrows"></span></li>
  </ul>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .more-list {
    .ml-item {
      display: flex;
      position: relative;
      align-items: center;
      height: 1.4rem;
      padding: .1rem 1rem .2rem .5rem;
      margin-bottom: .1rem;
      font-size: p2r(16);
      color: $a77;
      border-bottom: 1px solid rgba(182, 186, 195, .5);
      .arrows {
        display: block;
        position: absolute;
        right: .3rem;
        top: .5rem;
        width: .4rem;
        height: .4rem;
        background: url("img/arrow.png") center top no-repeat;
        background-size: .2rem;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {}
    },
    created(){
      document.title = '其他问题? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击其他问题')
    },
    methods: {
      skip(name) {
        this.$router.push({
          name: name
        });
      }
    },
    components: {}
  }
</script>
